__webpack_require__.p = "/wp-content/themes/strategic_vision_theme/assets/";